// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { BidPackageLineItemModal_BidPackageLineItemFragmentDoc } from './BidPackageLineItemModal.generated';
import { DisplayNamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ReviewUnitBidScopeStep_BidPackageGroupQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ReviewUnitBidScopeStep_BidPackageGroupQuery = { __typename?: 'Query', bidPackageGroup: { __typename?: 'BidPackageGroup', id: string, bidPackages: Array<{ __typename?: 'BidPackage', id: string, name: string, isPlanBasedV2: boolean, isProjectLevelBidding: boolean, isUnitBased: boolean, lineItems: Array<{ __typename?: 'BidPackageLineItem', id: string, bidItem: { __typename?: 'BidItem', id: string, displayName: string, items: Array<{ __typename?: 'Item', id: string, displayName: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }> } }>, costCodes: Array<{ __typename?: 'CostCode', id: string, displayName: string }>, latestVersion: { __typename?: 'BidPackageVersion', id: string, version: number, previous?: { __typename?: 'BidPackageVersion', id: string, lineItems: Array<{ __typename?: 'BidPackageLineItem', id: string, bidItem: { __typename?: 'BidItem', id: string } }> } | null | undefined }, status: { __typename?: 'BidPackageStatusDetail', code: Types.BidPackageStatus } }> } };

export type ReviewScopeStep_BidPackageFragment = { __typename?: 'BidPackage', id: string, name: string, isPlanBasedV2: boolean, isProjectLevelBidding: boolean, isUnitBased: boolean, lineItems: Array<{ __typename?: 'BidPackageLineItem', id: string, bidItem: { __typename?: 'BidItem', id: string, displayName: string, items: Array<{ __typename?: 'Item', id: string, displayName: string, costCode: { __typename?: 'CostCode', id: string, displayName: string } }> } }>, costCodes: Array<{ __typename?: 'CostCode', id: string, displayName: string }>, latestVersion: { __typename?: 'BidPackageVersion', id: string, version: number, previous?: { __typename?: 'BidPackageVersion', id: string, lineItems: Array<{ __typename?: 'BidPackageLineItem', id: string, bidItem: { __typename?: 'BidItem', id: string } }> } | null | undefined }, status: { __typename?: 'BidPackageStatusDetail', code: Types.BidPackageStatus } };

export const ReviewScopeStep_BidPackageFragmentDoc = gql`
    fragment ReviewScopeStep_BidPackage on BidPackage {
  id
  name
  isPlanBasedV2
  lineItems {
    ...BidPackageLineItemModal_BidPackageLineItem
  }
  costCodes {
    ...DisplayNamed
  }
  isProjectLevelBidding
  isUnitBased
  latestVersion {
    id
    previous {
      id
      lineItems {
        id
        bidItem {
          id
        }
      }
    }
    version
  }
  status {
    code
  }
}
    ${BidPackageLineItemModal_BidPackageLineItemFragmentDoc}
${DisplayNamedFragmentDoc}`;
export const ReviewUnitBidScopeStep_BidPackageGroupDocument = gql`
    query ReviewUnitBidScopeStep_BidPackageGroup($id: ID!) {
  bidPackageGroup(id: $id) {
    id
    bidPackages {
      ...ReviewScopeStep_BidPackage
    }
  }
}
    ${ReviewScopeStep_BidPackageFragmentDoc}`;

/**
 * __useReviewUnitBidScopeStep_BidPackageGroupQuery__
 *
 * To run a query within a React component, call `useReviewUnitBidScopeStep_BidPackageGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useReviewUnitBidScopeStep_BidPackageGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReviewUnitBidScopeStep_BidPackageGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReviewUnitBidScopeStep_BidPackageGroupQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReviewUnitBidScopeStep_BidPackageGroupQuery, ReviewUnitBidScopeStep_BidPackageGroupQueryVariables> & ({ variables: ReviewUnitBidScopeStep_BidPackageGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReviewUnitBidScopeStep_BidPackageGroupQuery, ReviewUnitBidScopeStep_BidPackageGroupQueryVariables>(ReviewUnitBidScopeStep_BidPackageGroupDocument, options);
      }
export function useReviewUnitBidScopeStep_BidPackageGroupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReviewUnitBidScopeStep_BidPackageGroupQuery, ReviewUnitBidScopeStep_BidPackageGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReviewUnitBidScopeStep_BidPackageGroupQuery, ReviewUnitBidScopeStep_BidPackageGroupQueryVariables>(ReviewUnitBidScopeStep_BidPackageGroupDocument, options);
        }
// @ts-ignore
export function useReviewUnitBidScopeStep_BidPackageGroupSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReviewUnitBidScopeStep_BidPackageGroupQuery, ReviewUnitBidScopeStep_BidPackageGroupQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReviewUnitBidScopeStep_BidPackageGroupQuery, ReviewUnitBidScopeStep_BidPackageGroupQueryVariables>;
export function useReviewUnitBidScopeStep_BidPackageGroupSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewUnitBidScopeStep_BidPackageGroupQuery, ReviewUnitBidScopeStep_BidPackageGroupQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReviewUnitBidScopeStep_BidPackageGroupQuery | undefined, ReviewUnitBidScopeStep_BidPackageGroupQueryVariables>;
export function useReviewUnitBidScopeStep_BidPackageGroupSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReviewUnitBidScopeStep_BidPackageGroupQuery, ReviewUnitBidScopeStep_BidPackageGroupQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReviewUnitBidScopeStep_BidPackageGroupQuery, ReviewUnitBidScopeStep_BidPackageGroupQueryVariables>(ReviewUnitBidScopeStep_BidPackageGroupDocument, options);
        }
export type ReviewUnitBidScopeStep_BidPackageGroupQueryHookResult = ReturnType<typeof useReviewUnitBidScopeStep_BidPackageGroupQuery>;
export type ReviewUnitBidScopeStep_BidPackageGroupLazyQueryHookResult = ReturnType<typeof useReviewUnitBidScopeStep_BidPackageGroupLazyQuery>;
export type ReviewUnitBidScopeStep_BidPackageGroupSuspenseQueryHookResult = ReturnType<typeof useReviewUnitBidScopeStep_BidPackageGroupSuspenseQuery>;
export type ReviewUnitBidScopeStep_BidPackageGroupQueryResult = ApolloReactCommon.QueryResult<ReviewUnitBidScopeStep_BidPackageGroupQuery, ReviewUnitBidScopeStep_BidPackageGroupQueryVariables>;